/*/
 * Fancybox v4
 *
 * data-fancybox + group-name
 *
/*/
	import { Fancybox } from "@fancyapps/ui"

	Fancybox.bind('[data-fancybox]', {
		infinite: false,
		Carousel: {
			Navigation: {
				prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 11.17 20.18"><path d="M0,10.09a1.05,1.05,0,0,1,.32-.76l9-9a1.07,1.07,0,0,1,1.52,1.52L2.6,10.09l8.26,8.26a1.07,1.07,0,0,1-1.52,1.52l-9-9A1,1,0,0,1,0,10.09"/></svg>',
				nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 11.17 20.18"><path d="M11.17,10.09a1.09,1.09,0,0,1-.32.76l-9,9A1.07,1.07,0,0,1,.31,18.35l8.26-8.26L.31,1.83A1.07,1.07,0,0,1,1.83.31l9,9a1.07,1.07,0,0,1,.32.76"/></svg>',
			},
		},
		Toolbar: {
			display: [
				// "counter",
				// "slideshow",
				// "thumbs",
				"close",
			],
			items: {
				counter: {
					type: "div",
					class: "fancybox__counter",
					html: '<span data-fancybox-index=""></span>&nbsp;/&nbsp;<span data-fancybox-count=""></span>',
					tabindex: -1,
					position: "left",
				},
				slideshow: {
					type: "button",
					class: "fancybox__button--slideshow",
					label: "TOGGLE_SLIDESHOW",
					html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><g><path d="M6 4v16"/><path d="M20 12L6 20"/><path d="M20 12L6 4"/></g><g><path d="M7 4v15M17 4v15"/></g></svg>`,
					click: function (event) {
						event.preventDefault();
						this.Slideshow.toggle();
					},
				},
				zoom: {
					type: "button",
					class: "fancybox__button--zoom",
					label: "TOGGLE_ZOOM",
					html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><circle cx="10" cy="10" r="7"></circle><path d="M16 16 L21 21"></svg>',
					click: function (event) {
						event.preventDefault();
						const panzoom = this.fancybox.getSlide().Panzoom;
						if (panzoom) {
							panzoom.toggleZoom();
						}
					},
				},
				thumbs: {
					type: "button",
					label: "TOGGLE_THUMBS",
					class: "fancybox__button--thumbs",
					html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><circle cx="4" cy="4" r="1" /><circle cx="12" cy="4" r="1" transform="rotate(90 12 4)"/><circle cx="20" cy="4" r="1" transform="rotate(90 20 4)"/><circle cx="4" cy="12" r="1" transform="rotate(90 4 12)"/><circle cx="12" cy="12" r="1" transform="rotate(90 12 12)"/><circle cx="20" cy="12" r="1" transform="rotate(90 20 12)"/><circle cx="4" cy="20" r="1" transform="rotate(90 4 20)"/><circle cx="12" cy="20" r="1" transform="rotate(90 12 20)"/><circle cx="20" cy="20" r="1" transform="rotate(90 20 20)"/></svg>',
					click: function (event) {
						event.stopPropagation();
						const thumbs = this.fancybox.plugins.Thumbs;
						if (thumbs) {
							thumbs.toggle();
						}
					},
				},
				close: {
					type: "button",
					label: "CLOSE",
					class: "fancybox__button--close",
					html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.49 26.49" tab-index="-1"><path d="M22.61,3.88a13.24,13.24,0,1,0,0,18.74A13.17,13.17,0,0,0,22.61,3.88ZM21.55,21.56a11.75,11.75,0,1,1,0-16.62A11.76,11.76,0,0,1,21.55,21.56ZM19.55,8,14.3,13.25l5.25,5.25-1.06,1.06-5.25-5.25L8,19.56,6.93,18.5l5.25-5.25L6.93,8,8,6.94l5.24,5.25,5.25-5.25Z"/></svg>',
					tabindex: 1,
					click: function (event) {
						event.stopPropagation();
						event.preventDefault();
						this.fancybox.close();
					},
				},
			}
		},
		Thumbs: {
			autoStart: true,
		},
		Hash: false,
		l10n: {
			CLOSE: "Fechar",
			NEXT: "Próxima",
			PREV: "Anterior",
			MODAL: "Você pode fechar essa modal pressionando ESC",
			ERROR: "Algo deu errado. Tente Novamente.",
			IMAGE_ERROR: "Imagem não encontrada",
			ELEMENT_NOT_FOUND: "Elemento HTML não encontrado",
			AJAX_NOT_FOUND: "Erro ao carregar AJAX : Não encontrado",
			AJAX_FORBIDDEN: "Erro ao carregar AJAX : Acesso restrito",
			IFRAME_ERROR: "Erro ao carregar página",
		}
	})
